import React from 'react'
import { UserAvatar24 } from '@carbon/icons-react'
import CustomUserAvatar from '../../../Avatar'
import Avatar from './components/Avatar'
import SettingsPanel from './components/SettingsPanel'
import { HeaderGlobalAction } from 'carbon-components-react'
import './index.scss'

const getInitials = (name = '', surname = '') =>
  `${name?.charAt(0) ?? ''}${surname?.charAt(0) ?? ''}`.toUpperCase()

export default function HeaderPanel({
  userAvatarSrc,
  userName = '',
  userSurname = '',
  avatarActions = [],
  userInfo = {},
  versions,
  location,
  settingsLabels,
  settingPanelContent
}) {
  const fullName = `${userName} ${userSurname}`.trim()

  const getAvatar = () => {
    if (!fullName) return <UserAvatar24 className='default-user-icon' />

    const props = userAvatarSrc
      ? { src: userAvatarSrc }
      : { text: getInitials(userName, userSurname) }

    return <CustomUserAvatar {...props} />
  }

  const getSettingsAvatar = () => {
    const props = userAvatarSrc ? { src: userAvatarSrc } : { text: '?' }
    return <CustomUserAvatar {...props} />
  }

  return (
    <div className='ublique-header-panel'>
      <HeaderGlobalAction className='ublique-user-actions'>
        <SettingsPanel
          settingsLabels={settingsLabels}
          settingPanelContent={settingPanelContent}
          versions={versions}
          getIcon={getSettingsAvatar}
          location={location}
        />
      </HeaderGlobalAction>
      <Avatar getAvatar={getAvatar} actions={avatarActions} user={userInfo} />
    </div>
  )
}
